import Cookies from "js-cookie"

type ConsentChange = {
    categoryId: string
    grantedAt: Date
    isGranted: boolean
}

export class TrackingManager {
    private cookieName: string
    private isSecure: boolean = window.location.protocol === "https:"

    private consentChanges: ConsentChange[] = []

    constructor(cookieName: string) {
        this.cookieName = cookieName
    }

    public switchCategoryState(
        categoryId: string | string[],
        isGranted: boolean
    ) {
        if (!Array.isArray(categoryId)) categoryId = [categoryId]

        for (const id of categoryId) {
            console.log("Switching State of Category:", { id, isGranted })
            this.consentChanges.push({
                categoryId: id,
                grantedAt: new Date(),
                isGranted,
            })
        }
    }

    public persist() {
        const cookieContent = Cookies.get(this.cookieName)
        const map = new URLSearchParams(cookieContent ?? "")

        for (const { categoryId, isGranted, grantedAt } of this
            .consentChanges) {
            // Delta Check
            if (map.get(categoryId) !== null) {
                const existingValue = map.get(categoryId)
                const alreadyGranted = existingValue !== "false"
                if (alreadyGranted === isGranted) {
                    // Do not change anything
                    continue
                }
            }

            map.set(categoryId, isGranted ? grantedAt.toISOString() : "false")
        }

        Cookies.set(this.cookieName, map.toString(), {
            //secure: this.isSecure,
            expires: new Date().getTime() + 365 * 24 * 60 * 60 * 1000, // 1 year
        })
    }
}
